export default __webpack_public_path__ + "23b698b5cb00897f49f87196b2d81fbf.png";